<template>
  <div class="sidebar">
    <i
      @click="closeMenu()"
      class="iconfont icon-close-noCircle hidden-sm-and-up"
    ></i>

    <div class="logo">
      <div class="logoWrap">
        <img class="logoImg" src="@/assets/images/common/logo.png" alt="" />
      </div>
      <div class="version">v 3.6.31</div>
    </div>

    <div class="listWrap">
      <div v-for="(item, index) in items" class="sidebarmain" :key="index">
        <div
          :class="item.index === barIndex ? 'barActive side rela' : 'side rela'"
          @click="showToggle(item)"
        >
          <img
            v-if="item.index === barIndex"
            class="itemicon"
            :src="item.iconActiveUrl"
            alt=""
          />
          <img v-else class="itemicon" :src="item.iconUrl" alt="" />
          <span>{{ item.title }}</span>
          <i
            class="arrow arrow-down el-icon-arrow-down"
            v-if="item.index === barIndex"
          ></i>
          <i class="arrow arrow-right el-icon-arrow-right" v-else></i>
        </div>
        <ul
          class="sideul"
          v-for="(sub, subindex) in item.subs"
          :key="subindex"
          v-show="item.index === barIndex"
        >
          <router-link
            :class="
              sub.url == listindex ? 'listActive rela liitem' : 'rela liitem'
            "
            :to="sub.url"
          >
            <p @click="todetail(item, sub.index, sub.url)">{{ sub.title }}</p>
          </router-link>

          <!-- <li :class="sub.index === listindex ?'listActive rela':'rela'" @click="todetail(item, sub.index, sub.url)">
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      barIndex: localStorage.getItem("barIndex") || "1",
      listindex: localStorage.getItem("listname") || "/userData",
      roleType: localStorage.getItem("roleType"),
      items: [
        {
          index: "1",
          title: "首頁",
          iconUrl: require("../assets/images/sidebar/homeIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/homeIconActive.png"),
          url: "/userData",
          subs: [
            {
              index: "1-1",
              title: "數據概覽",
              url: "/userData"
            }
          ]
        },
        {
          index: "2",
          title: "會員",
          iconUrl: require("../assets/images/sidebar/userIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/userIconActive.png"),
          subs: [
            {
              index: "2-1",
              title: "會員列表",
              url: "/userInfo"
            },
            {
              index: "2-3",
              title: "黑名單",
              url: "/blackList"
            },
            {
              index: "2-4",
              title: "賬號檢舉",
              url: "/reportList"
            }
          ]
        },
        {
          index: "3",
          title: "活動",
          iconUrl: require("../assets/images/sidebar/activityIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/activityIconActive.png"),
          subs: [
            {
              index: "3-1",
              title: "行事曆列表",
              url: "/calendarList"
            },
            {
              index: "3-2",
              title: "活動列表",
              url: "/activityList"
            },
            {
              index: "3-3",
              title: "核銷列表",
              url: "/checkActivity"
            }
          ]
        },
        {
          index: "4",
          title: "新聞",
          iconUrl: require("../assets/images/sidebar/newsIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/newsIconActive.png"),
          subs: [
            {
              index: "4-1",
              title: "新聞列表",
              url: "/newsList"
            },
            // {
            //   index: '4-2',
            //   title: 'vlog',
            //   url: '/newsVlog',
            // },
            {
              index: "4-2",
              title: "私密相簿",
              url: "/photoPrivacy"
            },
            {
              index: "4-3",
              title: "Wayne",
              url: "/JJdiary"
            },
            {
              index: "4-4",
              title: "評論投訴",
              url: "/commentComplaint"
            },
            {
              index: "4-5",
              title: "評論管理",
              url: "/comments"
            }
          ]
        },
        // {
        //   index: "5",
        //   title: "Banner管理",
        //   iconUrl: require("../assets/images/sidebar/bannerIcon.png"),
        //   iconActiveUrl: require("../assets/images/sidebar/bannerIcon.png"),
        //   subs: [
        //     {
        //       index: "5-1",
        //       title: "商城banner",
        //       url: "/marketBannerList"
        //     }
        //   ]
        // },
        {
          index: "6",
          title: "商城",
          iconUrl: require("../assets/images/sidebar/marketIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/marketIconActivve.png"),
          subs: [
            {
              index: "6-1",
              title: "商品列表",
              url: "/goodsList"
            },
            {
              index: "6-2",
              title: "溯源碼列表",
              url: "/memberGoodsList"
            }
          ]
        },
        // {
        //   index: '7',
        //   title: '行事曆',
        //   iconUrl: require('../assets/images/sidebar/calendarIcon.png'),
        //   iconActiveUrl:require('../assets/images/sidebar/calendarIconActive.png'),
        //   subs:[{
        //     index: '7-1',
        //     title: '行事曆列表',
        //     url: '/calendarList'
        //   }]
        // },
        {
          index: "7",
          title: "專輯",
          iconUrl: require("../assets/images/sidebar/specialEdition.png"),
          iconActiveUrl: require("../assets/images/sidebar/specialEditionActive.png"),
          subs: [
            {
              index: "7-1",
              title: "專輯列表",
              url: "/specialEditionList"
            }
          ]
        },

        // {
        //   index: '9',
        //   title: '金流',
        //   iconUrl: require('../assets/images/sidebar/moneyIcon.png'),
        //   iconActiveUrl:require('../assets/images/sidebar/moneyIconActive.png'),
        //   subs:[{
        //       index: '9-1',
        //       title: '金流管理',
        //       url: '/moneyOrder'
        //     },]
        // },
        {
          index: "9",
          title: "訂單",
          iconUrl: require("../assets/images/sidebar/orderIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/orderIconActive.png"),
          subs: [
            {
              index: "9-1",
              title: "所有訂單",
              url: "/moneyOrder"
            },
            {
              index: "9-2",
              title: "出貨订单",
              url: "/memberOrderList"
            },
            {
              index: "9-3",
              title: "售后订单",
              url: "/afterSalesList"
            },
            // {
            //   index: '9-3',
            //   title: '商城出貨',
            //   url: '/marketOrderList'
            // },
            // {
            //   index: '9-4',
            //   title: '扭蛋出貨',
            //   url: '/gashaponList'
            // },
            // {
            //   index: "9-5",
            //   title: "問題訂單",
            //   url: "/wrongOrder"
            // }
          ]
        },
        {
          index: "11",
          title: "簽到",
          iconUrl: require("../assets/images/sidebar/location.png"),
          iconActiveUrl: require("../assets/images/sidebar/activelocation.png"),
          subs: [
            {
              index: "11-1",
              title: "簽到列表",
              url: "/signList"
            },
            {
              index: "11-2",
              title: "評論投訴",
              url: "/commentList"
            }
          ]
        },
        {
          index: "12",
          title: "粉絲來信",
          iconUrl: require("../assets/images/sidebar/letter.png"),
          iconActiveUrl: require("../assets/images/sidebar/activeletter.png"),
          subs: [
            {
              index: "12-1",
              title: "信件列表",
              url: "/letterList"
            },
            {
              index: "12-2",
              title: "回信列表",
              url: "/replayList"
            }
          ]
        },
        {
          index: "13",
          title: "靈魂的共鳴",
          iconUrl: require("../assets/images/sidebar/sound.png"),
          iconActiveUrl: require("../assets/images/sidebar/activesound.png"),
          subs: [
            {
              index: "13-1",
              title: "合集列表",
              url: "/collectionList"
            },
            {
              index: "13-2",
              title: "評論投訴",
              url: "/collectionComplain"
            },
            {
              index: "13-3",
              title: "評論管理",
              url: "/collectionComments"
            }
          ]
        }
        // {
        //   index: '10',
        //   title: '社區',
        //   iconUrl: require('../assets/images/sidebar/community.png'),
        //   iconActiveUrl:require('../assets/images/sidebar/communityActive.png'),
        //   subs:[

        //     {
        //       index: '10-1',
        //       title: '話題列表',
        //       url: '/subjectList'
        //     },
        //     {
        //       index: '10-2',
        //       title: '帖子列表',
        //       url: '/postList'
        //     },
        //     {
        //       index: '10-3',
        //       title: '投訴列表',
        //       url: '/complaintList'
        //     },
        //   ]
        // },
        // {
        //   index: '15',
        //   title: '城市',
        //   iconUrl: require('../assets/images/sidebar/community.png'),
        //   iconActiveUrl:require('../assets/images/sidebar/communityActive.png'),
        //   subs:[

        //     {
        //       index: '15-1',
        //       title: '城市',
        //       url: '/city'
        //     },
        //   ]
        // },
      ],
      screenWidth: document.body.clientWidth,
      MenuShowFlag: false
    };
  },
  created() {
    // alert('created')
  },
  mounted() {
    let _this = this;
    _this.listindex = _this.$route.path;
    _this.roleName = localStorage.getItem("role");

    if (_this.screenWidth >= 768) {
      _this.MenuShowFlag = true;
    } else {
      _this.MenuShowFlag = false;
    }

    _this.roleType = localStorage.getItem("roleType");
    // 如果是super-admin和admin用户可以看到实名认证模块
    if (
      _this.roleType.indexOf("ROLE_ADMIN") > -1 ||
      _this.roleType.indexOf("ROLE_SUPER_ADMIN") > -1
    ) {
      _this.items[1].subs.push({
        index: "2-2",
        title: "實名認證",
        url: "/certificationList"
      });
    }

    // _this.items[1].subs.push(
    //
    //   {
    //     index: '2-4',
    //     title: '用戶數據',
    //     url: '/userData'
    //   }
    // )

    // taiwan无权限，圣奇瑞有权限
    if (_this.roleType.indexOf("ROLE_GUEST") > -1) {
      _this.items.push(
        {
          index: "14",
          title: "直播",
          iconUrl: require("../assets/images/sidebar/liveIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/liveIconActive.png"),
          subs: [
            {
              index: "14-1",
              title: "直播管理",
              url: "/liveList"
            }
          ]
        },
        {
          index: "16",
          title: "相關問題",
          iconUrl: require("../assets/images/sidebar/questionIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/questionIconActive.png"),
          subs: [
            {
              index: "16-1",
              title: "問題列表",
              url: "/replyQuestionList"
            },
          ]
        },
        {
          index: "8",
          title: "版本更新",
          iconUrl: require("../assets/images/sidebar/updateIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/updateIconActive.png"),
          subs: [
            {
              index: "8-1",
              title: "版本更新",
              url: "/editVersion"
            },
            {
              index: "8-2",
              title: "更新介紹",
              url: "/updateIntList"
            }
          ]
        }
      );

      _this.items[1].subs.push({
        index: "2-5",
        title: "意見反饋",
        url: "/feedback"
      });
    }else{
      _this.items.push(
       {
          index: "16",
          title: "相關問題",
          iconUrl: require("../assets/images/sidebar/liveIcon.png"),
          iconActiveUrl: require("../assets/images/sidebar/liveIconActive.png"),
          subs: [
            {
              index: "16-1",
              title: "問題列表",
              url: "/replyQuestionList"
            }
          ]
        },
      )
    }
    _this.items[1].subs.push({
      index: "2-6",
      title: "入會答題",
      url: "/questionList"
    });

    //全部用戶有權限
    _this.items.push({
      index: "15",
      title: "個人設置",
      iconUrl: require("../assets/images/sidebar/personSet.png"),
      iconActiveUrl: require("../assets/images/sidebar/personSetActive.png"),
      subs: [
        {
          index: "15-1",
          title: "帳號設置",
          url: "/accountSetting"
        },
        {
          index: "15-2",
          title: "修改密碼",
          url: "/alterPasswords"
        }
      ]
    });
  },
  activated() {
    let _this = this;
    _this.barIndex = localStorage.getItem("barIndex");
    _this.listindex = localStorage.getItem("listname");
  },
  methods: {
    // 导航栏展开收起
    showToggle(item) {
      let _this = this;
      if (_this.barIndex === item.index) {
        _this.barIndex = 0;
        localStorage.setItem("barIndex", _this.barIndex);
      } else {
        _this.barIndex = item.index;
        localStorage.setItem("barIndex", item.index);
      }
    },
    // 导航栏进入详情页
    todetail(item, index, url) {
      let _this = this;
      if (index === "4-3") {
        // JJ日记只有super-admin才可以看
        if (_this.roleType.indexOf("ROLE_SUPER_ADMIN") > -1) {
          _this.$emit("menuFlag", _this.MenuShowFlag);
          _this.listindex = url;
          localStorage.setItem("listname", url);
          localStorage.setItem("subIndex", index);
        } else {
          _this.permissionsTips();
          _this.$emit("menuFlag", _this.MenuShowFlag);
        }
      } else {
        if (!url.includes("/activityList")) {
          sessionStorage.setItem("currentPage", 1);
        }
        _this.$emit("menuFlag", _this.MenuShowFlag);
        _this.listindex = url;
        localStorage.setItem("listname", url);
        localStorage.setItem("subIndex", index);
      }
    },
    // 权限提示
    permissionsTips() {
      let _this = this;
      if (localStorage.getItem("subIndex") === null) {
        localStorage.setItem("subIndex", "1");
      }
      _this
        .$confirm("抱歉，您沒有權限訪問本欄目", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          let preBarIndex = localStorage.getItem("subIndex").split("-")[0];
          _this.barIndex = preBarIndex;
          localStorage.setItem("barIndex", _this.barIndex);
          _this.$router.go(-1);
        })
        .catch(() => {
          let preBarIndex = localStorage.getItem("subIndex").split("-")[0];
          _this.barIndex = preBarIndex;
          localStorage.setItem("barIndex", _this.barIndex);
          _this.$router.go(-1);
        });
    },
    // 关闭导航栏
    closeMenu() {
      let _this = this;
      _this.$emit("menuFlag", false);
    }
  }
};
</script>

<style scoped lang="less">
.sidebar {
  overflow: auto;
  display: block;
  width: 2.2rem;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(250, 250, 253, 1);
  box-shadow: 6px 0px 18px rgba(0, 0, 0, 0.08);
  z-index: 999;

  .icon-close-noCircle {
    position: absolute;
    top: 0.1rem;
    left: 0.1rem;
    color: #666;
  }

  .logo {
    width: 100%;
    padding: 0 0.3rem;
    margin: 0.3rem 0 0.3rem 0;
    text-align: center;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    // justify-content: space-between;
    justify-content: center;

    .logoWrap {
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: center;
      width: 0.5rem;
      height: 1rem;
      line-height: 0.6rem;

      .logoImg {
        width: 100%;
      }
    }
    .version {
      color: black;
    }
  }

  .listWrap {
    // overflow: auto;
    .sidebarmain {
      width: 100%;
      min-height: 0.55rem;
      -webkit-transition: height 0.5s;
      transition: height 0.5s;

      .side {
        width: 100%;
        height: 0.5rem;
        text-align: left;
        line-height: 0.65rem;
        padding: 0 0.15rem 0 0.2rem;
        display: flex;
        align-items: center;

        .itemicon {
          width: 0.14rem;
          color: rgba(147, 142, 164, 1);
        }

        span {
          display: inline-block;
          color: #938ea4;
          font-size: 0.14rem;
          cursor: pointer;
          padding-left: 0.2rem;
        }

        .arrow {
          font-size: 0.1rem;
          position: absolute;
          right: 0.1rem;
          top: 0.25rem;
        }

        .arrow-down {
          color: #292929;
        }

        .arrow-right {
          color: #938ea4;
        }
      }

      .barActive {
      }

      .sideul {
        width: 100%;
        list-style: none;

        .liitem {
          display: inline-block;
          width: 100%;
          height: 0.45rem;
          line-height: 0.45rem;
          text-align: center;

          i {
            font-size: 0.1rem;
            color: #bababa;
          }

          p {
            width: 100%;
            color: #938ea4;
            display: inline-block;
            font-size: 0.14rem;
            cursor: pointer;
          }
        }

        .listActive {
          background: rgba(245, 245, 252, 1);
          border-right: 0.04rem solid rgba(108, 61, 234, 1);

          p {
            font-family: PingFang SC;
            color: rgba(108, 61, 234, 1);
            font-weight: 600;
          }
        }
      }

      ul.sideul:not(:first-of-type) {
        // border-top: 1px solid rgba(255,255,255,0.2)
      }
    }

    .sidebarmain:last-child {
      // border-bottom: 0.02rem solid @mainDarkerColor;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue